export const SIGNATURE = {
  "Signature.Bg.Color": {
    ref: "Input.Readonly.Bg.Color"
  },
  "Signature.Border.Top.Left.Radius": {
    ref: "Input.Readonly.Border.Top.Left.Radius"
  },
  "Signature.Border.Top.Right.Radius": {
    ref: "Input.Readonly.Border.Top.Right.Radius"
  },
  "Signature.Border.Bottom.Right.Radius": {
    ref: "Input.Readonly.Border.Bottom.Right.Radius"
  },
  "Signature.Border.Bottom.Left.Radius": {
    ref: "Input.Readonly.Border.Bottom.Left.Radius"
  },
  "Signature.Button.Border.Color": {
    ref: "Button.Tertiary.Border.Color"
  },
  "Signature.Border.Color": {
    ref: "Input.Readonly.Border.Color"
  },
  "Signature.Border.Left.Width": {
    ref: "Input.Border.Left.Width"
  },
  "Signature.Border.Right.Width": {
    ref: "Input.Border.Right.Width"
  },
  "Signature.Border.Top.Width": {
    ref: "Input.Border.Top.Width"
  },
  "Signature.Border.Bottom.Width": {
    ref: "Input.Border.Bottom.Width"
  }
};
